import { LIVE_CHAT_ONLINE_ELEMENT_ID } from "components/LiveChat/liveChat.helpers";

export const LiveChatHiddenControl = () => (
  // Salesforce checks its servers every 50 seconds and hides/shows this element based on chat availability
  // The element always needs to exist or Salesforce will throw errors while trying to modify its inline "display" style
  <span hidden id={LIVE_CHAT_ONLINE_ELEMENT_ID}></span>
);
